'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$CategoryId$() {
  this.a9K = 0;
  this.a9L = 0;
  $n_Lmealorama_model$package$CategoryId$ = this;
  $m_Lmealorama_model$package$CategoryId$();
  this.a9K = 0;
  this.a9L = 0;
}
export { $c_Lmealorama_model$package$CategoryId$ as $c_Lmealorama_model$package$CategoryId$ };
$p = $c_Lmealorama_model$package$CategoryId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$CategoryId$;
/** @constructor */
function $h_Lmealorama_model$package$CategoryId$() {
}
export { $h_Lmealorama_model$package$CategoryId$ as $h_Lmealorama_model$package$CategoryId$ };
$h_Lmealorama_model$package$CategoryId$.prototype = $p;
var $d_Lmealorama_model$package$CategoryId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$CategoryId$, "mealorama.model$package$CategoryId$", ({
  KN: 1
}));
export { $d_Lmealorama_model$package$CategoryId$ as $d_Lmealorama_model$package$CategoryId$ };
var $n_Lmealorama_model$package$CategoryId$;
function $m_Lmealorama_model$package$CategoryId$() {
  if ((!$n_Lmealorama_model$package$CategoryId$)) {
    $n_Lmealorama_model$package$CategoryId$ = new $c_Lmealorama_model$package$CategoryId$();
  }
  return $n_Lmealorama_model$package$CategoryId$;
}
export { $m_Lmealorama_model$package$CategoryId$ as $m_Lmealorama_model$package$CategoryId$ };
//# sourceMappingURL=mealorama.model$package$-Category-Id$.js.map
